import { GET_CURRENCIES } from "@/store/modules/user/consts";
import { getCurrenciesCacheKey } from "@/utils/sessionDataCache";

/**
 * Stable id list for comparing currency payloads without replacing Vuex unnecessarily.
 */
export function currenciesListSignature(list) {
  if (!Array.isArray(list) || !list.length) {
    return "";
  }
  return list.map((item) => item.id).join("|");
}

/**
 * True when Vuex has a non-empty currency list for this cart amount/currency/merchant.
 */
export function hasLoadedCurrenciesForCart(state, cart) {
  const key = getCurrenciesCacheKey(cart);
  return Boolean(
    key &&
      state.apiCache?.currenciesKey === key &&
      Array.isArray(state.currencies) &&
      state.currencies.length > 0
  );
}

/**
 * Whether a network call to /currencies is needed for this cart.
 */
export function needsCurrenciesFetch(state, cart) {
  return Boolean(cart?.merchant_id) && !hasLoadedCurrenciesForCart(state, cart);
}

/**
 * Single entry for loading /currencies. Deduped in the Vuex action (cache + in-flight).
 *
 * @param {import('vuex').Store} store
 * @param {object} cart
 * @param {{ force?: boolean }} options - force=true bypasses cache (settings/preview refresh)
 */
export function loadCurrenciesForCart(store, cart, { force = false } = {}) {
  if (!cart?.merchant_id) {
    return Promise.resolve(store.state.user.currencies || []);
  }

  const state = store.state.user;
  if (!force && hasLoadedCurrenciesForCart(state, cart)) {
    return Promise.resolve(state.currencies);
  }

  return store.dispatch(`user/${GET_CURRENCIES}`, {
    merchantId: cart.merchant_id,
    amount: cart.amount,
    currency: cart.currency,
  });
}
